type PageMetaConfig = {
  title: string;
  description: string;
  themeColor: string;
  ogImage: string;
  ogImageAlt: string;
  twitterCard: 'summary' | 'summary_large_image';
  robots?: 'index,follow' | 'noindex,nofollow';
};

function setMeta(selector: string, attribute: 'content' | 'href', value: string) {
  const element = document.querySelector(selector);
  if (!element) return;
  element.setAttribute(attribute, value);
}

export function applyPageMeta(config: PageMetaConfig) {
  const url = `${window.location.origin}${window.location.pathname}`;

  document.title = config.title;
  setMeta('meta[name="robots"]', 'content', config.robots ?? 'noindex,nofollow');
  setMeta('meta[name="description"]', 'content', config.description);
  setMeta('meta[name="theme-color"]', 'content', config.themeColor);
  setMeta('link[rel="canonical"]', 'href', url);
  setMeta('meta[property="og:site_name"]', 'content', 'TÜV SÜD Academy');
  setMeta('meta[property="og:type"]', 'content', 'website');
  setMeta('meta[property="og:title"]', 'content', config.title);
  setMeta('meta[property="og:description"]', 'content', config.description);
  setMeta('meta[property="og:url"]', 'content', url);
  setMeta('meta[property="og:image"]', 'content', config.ogImage);
  setMeta('meta[property="og:image:alt"]', 'content', config.ogImageAlt);
  setMeta('meta[name="twitter:card"]', 'content', config.twitterCard);
  setMeta('meta[name="twitter:title"]', 'content', config.title);
  setMeta('meta[name="twitter:description"]', 'content', config.description);
  setMeta('meta[name="twitter:image"]', 'content', config.ogImage);
}
